const keywords = {
    list: () => 'filterKeywords',
    create:()=>'createKeyword',
    update: (id) => `updateKeyword/${id}`,
    getById: (id) => `getKeywordById/${id}`,
    delete: (id) => `deleteKeyword/${id}`,
}
export default keywords
